import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  create,
  readFlow,
  reset,
  Shape as FlowShape,
} from 'next/entities/flows';
import { asRequest, NEW_ITEM_ID } from 'next/entities/requests';
import {
  selectTagsOptions,
  selectTemplateOptions,
} from 'next/lib/selectors-options';
import { SelectOptionsShape } from 'next/lib/shapes';
import {
  FLOW_TYPE,
  CreateExperienceModalManager,
} from 'next/components/CreateExperience';

import TemplatesField from './TemplatesField';

export const NewFlowManager = ({
  onOpen,
  onSubmit,
  flowStatus = {},
  tagOptions,
  templateOptions,
}) => {
  const handleSubmit = values =>
    onSubmit({
      name: values.name,
      previewUrl: values.previewUrl,
      tagIds: values.tagIds,
      template: values.template?.value,
    });

  const initialValues = { template: null };

  return (
    <CreateExperienceModalManager
      initialValues={initialValues}
      onOpen={onOpen}
      onSubmit={handleSubmit}
      renderAdditionalFields={({ onChange }) => (
        <TemplatesField
          onChange={template => onChange({ template })}
          templateOptions={templateOptions}
        />
      )}
      status={flowStatus}
      tags={tagOptions}
      type={FLOW_TYPE}
    />
  );
};

NewFlowManager.propTypes = {
  onOpen: PropTypes.func,
  onSubmit: PropTypes.func,
  flowStatus: asRequest(PropTypes.objectOf(FlowShape)),
  tagOptions: SelectOptionsShape,
  templateOptions: SelectOptionsShape,
};

const mapStateToProps = state => ({
  flowStatus: readFlow(state, NEW_ITEM_ID),
  tagOptions: selectTagsOptions(state),
  templateOptions: selectTemplateOptions(),
});

const mapDispatchToProps = {
  onOpen: () => reset(NEW_ITEM_ID),
  onSubmit: values => create(values),
};

export default connect(mapStateToProps, mapDispatchToProps)(NewFlowManager);
